export function getSiteOrigin(): string {
  const fromEnv = process.env.REACT_APP_SITE_URL?.replace(/\/$/, '')

  if (typeof window !== 'undefined') {
    return fromEnv || window.location.origin
  }

  return fromEnv || ''
}
